// Small presentational helpers used inside Checkout.jsx — the all-caps
// section label, the radio row, the price-line row, and the shared input
// style for text fields.

import { C } from "../../lib/theme";
import { Icon } from "../../components/Icon";

export function Label({ children }) {
  return (
    <div
      style={{
        fontSize:      10.5,
        fontWeight:    800,
        color:         C.muted,
        textTransform: "uppercase",
        letterSpacing: 1,
        marginBottom:  8,
      }}
    >
      {children}
    </div>
  );
}

export function RadioRow({ icon, label, hint, selected, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        all:        "unset",
        cursor:     "pointer",
        display:    "flex",
        alignItems: "center",
        gap:        12,
        padding:    "12px 14px",
        borderRadius: 12,
        border:     selected ? `2px solid ${C.hunter}` : "1px solid rgba(196,193,183,0.35)",
        background: selected ? C.cream : C.white,
      }}
    >
      {icon && (
        <span
          style={{
            width:        32,
            height:       32,
            borderRadius: 10,
            background:   C.cream,
            display:      "inline-flex",
            alignItems:   "center",
            justifyContent: "center",
          }}
        >
          <Icon name={icon} size={14} color={C.hunter} />
        </span>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: C.charcoal }}>{label}</div>
        <div
          style={{
            fontSize:     11,
            color:        C.muted,
            overflow:     "hidden",
            textOverflow: "ellipsis",
            whiteSpace:   "nowrap",
          }}
        >
          {hint}
        </div>
      </div>
      <div
        style={{
          width:        20,
          height:       20,
          borderRadius: "50%",
          border:       `2px solid ${selected ? C.hunter : C.dustDk}`,
          background:   selected ? C.hunter : "transparent",
          display:      "inline-flex",
          alignItems:   "center",
          justifyContent: "center",
          flexShrink:   0,
        }}
      >
        {selected && (
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: C.white }} />
        )}
      </div>
    </button>
  );
}

export function Row({ label, value, bold }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", fontSize: bold ? 14 : 12.5 }}>
      <span style={{ color: C.muted, fontWeight: bold ? 800 : 600 }}>{label}</span>
      <span style={{ color: C.charcoal, fontWeight: bold ? 900 : 700 }}>{value}</span>
    </div>
  );
}

export const inputStyle = {
  width:        "100%",
  padding:      "10px 12px",
  border:       "1px solid rgba(196,193,183,0.4)",
  borderRadius: 10,
  fontSize:     13,
  color:        C.charcoal,
  background:   C.white,
  outline:      "none",
  boxSizing:    "border-box",
};
